import MojitoModules from 'mojito/modules';

import {merge} from '#core/utils/config-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {generateParticipants} from '#core/application/modules/tiles/participants/index.js';
import {generateEventTimingStatus} from '#core/application/modules/tiles/event-timing-status/index.js';
import {generateBaseScoreboard, generateScoreboard} from '#core/application/modules/tiles/scoreboard/index.js';
import {generateOddsButton} from '#core/application/modules/tiles/odds-button/index.js';

const SelectionButtonTypes = MojitoModules.SelectionButton.types;

const EVENT_CARD_OVER_UNDER_DESCRIPTORS = {
    categories: {
        OVER_UNDER: {selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW_SHORT},
        OVER_EXACTLY_UNDER: {selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW_SHORT},
        OVER_UNDER_THREE_WAY: {selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW_SHORT},
    },
};

export function matchCardsFactory(PALETTE) {
    const CARD_SCOREBOARD = generateScoreboard({
        ...PALETTE.CARD_SCOREBOARD,
        SCOREBOARD_PARTICIPANTS: PALETTE.CARD_PARTICIPANTS,
        SCOREBOARD_TIMING_STATUS: PALETTE.CARD_TIMING_STATUS,
    });
    const CARD_MINI_SCOREBOARD = merge(generateBaseScoreboard(PALETTE.CARD_SCOREBOARD), {
        scoresTextMain: {
            backgroundImage: 'initial',
            ...resolveBackground(PALETTE.CARD_SCOREBOARD.SCOREBOARD_ACTIVE_SCORE_BG),
            ...PALETTE.CARD_SCOREBOARD.SCOREBOARD_ACTIVE_SCORE_TEXT,
        },
        scoresTextSecondary: {
            width: '20px',
        },
        scoreCount: {
            style: {
                scoreText: {
                    backgroundImage: 'initial',
                    ...resolveBackground(PALETTE.CARD_SCOREBOARD.SCOREBOARD_ACTIVE_SCORE_BG),
                    ...PALETTE.CARD_SCOREBOARD.SCOREBOARD_ACTIVE_SCORE_TEXT,
                },
            },
        },
    });

    return {
        MatchEventCard: {
            showBackgroundSportImage: !PALETTE.PARENT.CARD_WATERMARK_ICON_HIDDEN,
            eventCard: {
                title: {
                    truncate: true,
                    style: PALETTE.CARD_EVENT_NAME_TEXT,
                },
            },
            genericMarketContent: {
                layoutDescriptors: EVENT_CARD_OVER_UNDER_DESCRIPTORS,
                container: {
                    style: {
                        backgroundColor: 'transparent',
                        backgroundImage: 'none',
                    },
                },
                market: {
                    selectionButton: merge(generateOddsButton(PALETTE.EVENT_CARDS_ODDS_BUTTON), {
                        view: {
                            infoText: {
                                ellipsisOnLineNumber: 1,
                            },
                        },
                    }),
                },
            },
            gameLineMarketContent: {
                layoutDescriptors: EVENT_CARD_OVER_UNDER_DESCRIPTORS,
                container: {
                    style: {
                        flexBasis: 0,
                        backgroundColor: 'transparent',
                        backgroundImage: 'none',
                    },
                },
                marketsContainer: {
                    style: {
                        _mobile_flexBasis: 'auto',
                    },
                },
                market: {
                    headerLabel: {
                        style: PALETTE.CARD_GAMELINE_MARKET_HEADER_TEXT,
                    },
                    selectionButton: generateOddsButton(PALETTE.EVENT_CARDS_ODDS_BUTTON),
                },
                participants: merge(generateParticipants(PALETTE.CARD_PARTICIPANTS), {
                    participantItem: {
                        textWrapper: {
                            style: {
                                justifyContent: 'center',
                            },
                        },
                    },
                }),
                scoreboard: CARD_MINI_SCOREBOARD,
            },
            playerPropMarketContent: {
                layoutDescriptors: EVENT_CARD_OVER_UNDER_DESCRIPTORS,
            },
            headerContainer: {
                style: {
                    padding: '0 8px 6px',
                    alignItems: 'center',
                    flexGrow: 0,
                    flexShrink: 0,
                    flexBasis: 'auto',
                },
            },
            marketTitle: {
                style: PALETTE.CARD_MARKET_NAME_TEXT,
            },
            headerTime: generateEventTimingStatus(PALETTE.CARD_TIMING_STATUS),
            sportIcon: {
                icon: {
                    style: {
                        fill: PALETTE.CARD_SPORT_ICON_COLOR,
                        minWidth: 12,
                    },
                },
            },
            eventItemDetails: {
                container: {
                    style: {
                        padding: '0 8px 8px',
                    },
                },
                participants: merge(generateParticipants(PALETTE.CARD_PARTICIPANTS), {
                    participantItem: {
                        text: {
                            container: {
                                display: 'flex',
                                padding: '2px 0', // same as scoreText in miniScoreboard, see DBX-7944
                            },
                            style: {
                                lineHeight: '16px',
                            },
                        },
                    },
                }),
                scoreboard: merge(CARD_MINI_SCOREBOARD, {
                    scoreCount: {
                        style: {
                            goalContainer: {
                                zIndex: 'auto',
                            },
                        },
                    },
                }),
            },
            scoreboard: merge(CARD_SCOREBOARD, {
                container: {
                    style: {
                        padding: '0 8px',
                        backgroundImage: 'none',
                    },
                },
                content: {
                    style: {
                        backgroundColor: 'none',
                        _desktop_boxShadow: 'none',
                        _mobile_boxShadow: 'none',
                    },
                },
            }),
        },
    };
}
